<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>
    <b-container fluid class="container-fluid mt--6">
      <b-row class="justify-content-center">
        <b-col lg="8" class="card-wrapper ct-example">
          <!-- Styles -->
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Add New</h3>
            </b-card-header>
            <b-card-body>
              <form>
                <b-row class="form-group">
                  <b-col md="12">
                    <base-input
                      label="Title"
                      type="text"
                      placeholder="Title"
                      :state="Boolean(inputs.title)"
                      v-model="inputs.title"
                    />
                  </b-col>
                  <!-- <b-col md="6">
                    <base-input
                      label="Schedule At"
                      v-model="inputs.scheduled"
                      type="datetime-local"
                      value="2018-11-23T10:30:00"
                      :state="Boolean(inputs.scheduled)"
                      id="example-datetime-local-input"
                    />
                  </b-col> -->
                </b-row>
                <b-row class="form-group">
                  <b-col md="12">
                    <b-form-file
                      v-model="inputs.file"
                      @input="filesChange"
                      :state="Boolean(inputs.file)"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      ref="file"
                      placeholder="Select file (CSV Only)"
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="12" class="text-right">
                    <div v-if="progress > 0">{{ progress }}%</div>
                    <div v-else-if="progress < 0" class="danger">
                      Please reselect the file
                    </div>
                    <div v-else-if="progress === 100" class="success">
                      File uploaded
                    </div>
                    <div v-else></div>
                    <base-button
                      icon
                      type="info"
                      @click.prevent="downloadSample()"
                    >
                      <span class="btn-inner--icon"
                        ><i class="ni ni-book-bookmark"></i
                      ></span>
                      <span class="btn-inner--text">Sample CSV</span>
                    </base-button>
                    <base-button icon type="success" @click="onUploadClick()">
                      <span class="btn-inner--icon"
                        ><i class="ni ni-bag-17"></i
                      ></span>
                      <span class="btn-inner--text">Upload</span>
                    </base-button>
                  </b-col>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
          <!-- Colors -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import { BasePagination } from "@/components";
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import moment from "moment";
import csvFile from "../../assets/SampleEmployeeReport.csv";
import { API } from "../../services/api.service";
export default {
  name: "ai-suraksha",
  data: function() {
    return {
      inputs: {
        title: ""
      },
      progress: 0,
      errors: []
    };
  },
  components: {
    // BasePagination,
    BaseHeader
    // RouteBreadcrumb
  },
  methods: {
    validate() {
      this.errors = [];
      if (!this.inputs.title) this.errors.push("Title Required!");
      if (!this.inputs.file_id) this.errors.push("File Required!");
    },
    onUploadClick() {
      this.validate();
      try {
        if (!this.errors.length) {
          let dataObj = {
            attachment: {
              name: this.inputs.title,
              file_name: this.inputs.title,
              file_id: this.inputs.file_id
            }
          };
          API.CREATE_MHW(dataObj)
            .then(res => {
              if (res.data.ok) {
                swal.fire({
                  title: `Document Uploaded Successfully!`,
                  buttonsStyling: false,
                  type: "success",
                  confirmButtonClass: "btn btn-success btn-fill"
                });
              }
            })
            .catch(err => {
              let error = "SOmething went Wrong!";
              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.message
              )
                error = err.response.data.message;
              swal.fire({
                title: `${error}`,
                buttonsStyling: false,
                type: "error",
                confirmButtonClass: "btn btn-danger btn-fill"
              });
            });
        } else throw this.errors[0];
      } catch (e) {
        swal.fire({
          title: `${e}`,
          buttonsStyling: false,
          type: "error",
          confirmButtonClass: "btn btn-danger btn-fill"
        });
      }
    },
    downloadSample() {
      const blob = new Blob([csvFile], { type: "csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "SampleEmployeeReport.csv";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    progressUpdate(progressEvent) {
      this.progress = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },
    filesChange(files) {
      var parts = files.name.split(".");
      if (parts.pop() === "csv") {
        let formData = new FormData();
        formData.append("file", this.inputs.file);

        API.UPLOAD_FILE(this.progressUpdate, formData)
          .then(res => {
            this.inputs.file_id = res.data.result.fileId;
          })
          .catch(err => {
            swal.fire({
              title: `${err && err.response && err.response.data.message}`,
              buttonsStyling: false,
              type: "error",
              confirmButtonClass: "btn btn-danger btn-fill"
            });
            this.inputs.file = null;
          });
      } else {
        swal.fire({
          title: `File Type Not Supported!`,
          buttonsStyling: false,
          type: "error",
          confirmButtonClass: "btn btn-danger btn-fill"
        });
        this.inputs.file = null;
      }
    }
  }
};
</script>
